<template>
     <!-- Clients -->
  <section class="py-5">
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-sm-6">
          <a href="#">
            <img class="img-fluid d-block mx-auto" src="./../../assets/img/logos/envato.jpg" alt="">
           </a>
        </div>
        <div class="col-md-3 col-sm-6">
          <a href="#">
            <img class="img-fluid d-block mx-auto" src="./../../assets/img/logos/designmodo.jpg" alt="">
          </a>
        </div>
        <div class="col-md-3 col-sm-6">
          <a href="#">
            <img class="img-fluid d-block mx-auto" src="./../../assets/img/logos/themeforest.jpg" alt="">
          </a>
        </div>
        <div class="col-md-3 col-sm-6">
          <a href="#">
            <img class="img-fluid d-block mx-auto" src="./../../assets/img/logos/creative-market.jpg" alt="">
          </a>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
    name:'clients-component'
}
</script>



// WEBPACK FOOTER //
// src/components/ClientsComponent/clientsComponent.vue